import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useState, useMemo } from 'react';
import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Card, CardContent, CardMedia, Chip, CircularProgress, Divider, Grid, List, ListItem, ListItemButton, ListItemText, Stack, styled, Tooltip, Typography } from '@mui/material';
import { useHistory, useLocation } from 'react-router-dom';
import ApiService from '../../_services/ApiService';
import playlist from '../../img/default-image.png'
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { getDateAsPerFormat } from '../../_helpers/reusablefunctions/dateSetter';
import GetMoodGenreLanguage from '../../_helpers/reusablefunctions/getMoodGenreLanguage';
import EditIcon from '@mui/icons-material/Edit';
import { getSongStatusBgColor } from '../../_helpers/reusablefunctions/getColor';
import { useParams } from 'react-router-dom';
import MusicNoteIcon from '@mui/icons-material/MusicNote';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import DateRangeOutlinedIcon from '@mui/icons-material/DateRangeOutlined';
import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import TagOutlinedIcon from '@mui/icons-material/TagOutlined';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import PlayArrowOutlinedIcon from "@mui/icons-material/PlayArrowOutlined";
import CropSquareOutlinedIcon from "@mui/icons-material/CropSquareOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import FacebookIcon from '@mui/icons-material/Facebook';
import useHandleRazorPayment from './paymentRazorpay';

const getChipStyles = (status = "") => {
    const normalized = status.replaceAll(" ", "_").toLowerCase();

    if (normalized === "upcoming") {
        return { bg: "#eafdee", color: "#219653" };
    }

    if (normalized === "new") {
        return { bg: "#E8E8E8", color: "#7A7A7A" };
    }

    if (normalized === "underreview" || normalized === "under_review" || normalized === "underReview" || normalized === "UnderReview") {
        return { bg: "#DAA827", color: "#FFFFFF" };
    }

    if (normalized === 'Approved' || normalized === 'completed' || normalized === 'Completed') {
        return { bg: "#3EBD02", color: "#FFFFFF" };
    }

    if (normalized === 'Rejected' || normalized === 'rejected') {
        return { bg: "#E92726", color: "#FFFFFF" };
    }

    if (normalized === 'ready_for_release') {
        return { bg: "#FCAC62", color: "#FFFFFF" };
    }

    return {
        bg: getSongStatusBgColor(status),
        color: "#FFFFFF",
    };
};

const getPlatformIcon = (name = "") => {
    const normalized = name.toLowerCase();

    if (normalized.includes("youtube")) {
        return <YouTubeIcon sx={{ color: "#FF0000" }} />;
    }

    if (normalized.includes("instagram")) {
        return <InstagramIcon sx={{ color: "#E1306C" }} />;
    }

    if (normalized.includes("facebook")) {
        return <FacebookIcon sx={{ color: "#1877F2" }} />;
    }

    return null;
};

const formatINR = (value) => {
    if (!value && value !== 0) return "--";
    return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR",
        maximumFractionDigits: 0,
    }).format(value);
};

export default function CampaignDetail() {
    const history = useHistory();
    const location = useLocation();
    const [campaignDetail, setCampaignDetail] = useState(location?.state)
    const [statusCount, setStatusCount] = useState(null)
    const { tab } = useParams();
    const { bg, color } = getChipStyles(campaignDetail?.progress);
    const handlePayment = useHandleRazorPayment();
    { console.debug("campaignDetail", campaignDetail) }
    // -------------API Calls song promotion & campaign

    useEffect(() => {
        if (campaignDetail.status) {
            switch (campaignDetail.status) {
                case 'UnderReview':
                    setStatusCount(25)
                    break;
                case 'SongPromotionLive':
                    setStatusCount(75)
                    break;
                case 'Completed':
                    setStatusCount(100)
                    break;
                case 'Rejected':
                    setStatusCount(0)
                    break;
                default:
                    break;
            }
        }
    }, [campaignDetail])

    // back to prev

    function backtoprevious() {
        history.push(`/campaign?tab=${tab}`);
    }

    const isUpcoming = campaignDetail?.status === 'upcoming';

    const displayTitle = isUpcoming
        ? campaignDetail?.demoName
        : campaignDetail?.songName;

    const displayPoster = isUpcoming
        ? (campaignDetail?.demoPoster_url || playlist)
        : (
            campaignDetail?.songPoster300x300
                ? campaignDetail?.songPoster300x300
                : campaignDetail?.songPoster_url
                    ? campaignDetail?.songPoster_url
                    : campaignDetail?.songPoster
                        ? process.env.REACT_APP_BASEURL_MEDIA + '/media/' + campaignDetail?.songPoster
                        : campaignDetail?.cover_image
                            ? process.env.REACT_APP_SONGAPIURL_MEDIA + campaignDetail?.cover_image
                            : playlist
        );

    const capitalizeFirst = (value = "") =>
        value ? value.charAt(0).toUpperCase() + value.slice(1) : "";
    return (
        <Box className='container-fluid py-2 px-4 creator-playlist-panel' mt={1} mb={6}>
            <Box>
                <Button
                    className="text-black text-capitalize fs-5"
                    onClick={backtoprevious}
                    startIcon={<KeyboardBackspaceIcon />}
                >
                    {/* {displayTitle || "--"} */}
                    Song Details
                </Button>
            </Box>

            <Grid container spacing={2} mt={0}>
                <Grid item xs={12} sm={4} md={4} sx={{
                    position: { xs: "static", sm: "sticky" },
                    top: "64px",
                    alignSelf: "flex-start",
                    height: "fit-content",
                }}>
                    <Box>
                        <Box position="relative" width="100%" borderRadius={'8px'} overflow={'hidden'}>
                            <CardMedia
                                component="img"
                                sx={{
                                    aspectRatio: '1 / 1',
                                    width: '100%',
                                    objectFit: 'cover',
                                }}
                                // image={
                                //     campaignDetail?.songPoster300x300
                                //         ? campaignDetail?.songPoster300x300
                                //         : campaignDetail?.songPoster_url
                                //             ? campaignDetail?.songPoster_url
                                //             : campaignDetail?.songPoster
                                //                 ? process.env.REACT_APP_BASEURL_MEDIA + '/media/' + campaignDetail?.songPoster
                                //                 : campaignDetail?.cover_image ? process.env.REACT_APP_SONGAPIURL_MEDIA + campaignDetail?.cover_image
                                //                     : playlist}
                                image={displayPoster}
                            />
                            {/* <Chip className='chipStyle' label={capitalizeFirst(campaignDetail?.source)} /> */}
                        </Box>
                        <Card sx={{ borderRadius: 3, p: 2, mt: 2 }}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: "center", }}>
                                <Box
                                    sx={{
                                        width: "50px",
                                        height: "50px",
                                        background: "#FFF1F1",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: "16px",
                                    }}
                                >
                                    <MusicNoteIcon sx={{ fontSize: 28, color: '#ed3237', }} />
                                </Box>
                                <Typography sx={{ fontsize: '16px', fontWeight: 500 }}>{displayTitle || '--'}</Typography>
                            </Box></Card>
                        {/* <CardContent>
                            <Typography variant="body2" component={'div'} className='d-flex align-items-baseline gap-2 flex-grow-1' sx={{ color: 'text.secondary', margin: '8px 0px' }}>
                                <Typography variant="subtitle2" gutterBottom>Song Name:</Typography>
                                {/* {campaignDetail?.songName || '--'} 
                                {displayTitle || '--'}
                            </Typography>
                        </CardContent> */}
                    </Box>
                </Grid>
                <Grid item xs={12} sm={8} md={8} >
                    <Card sx={{ borderRadius: 3 }}>
                        <Box mt={1} sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }} className='pt-2 px-3'>
                            <Typography sx={{ fontsize: '30px', fontWeight: 600 }}>Campaign Overview</Typography>
                            <Stack direction="row" spacing={1}>
                                <Chip
                                    className="p-2"
                                    sx={{
                                        backgroundColor: bg,
                                        color: color,
                                        fontWeight: 600,
                                        textTransform: "capitalize",
                                    }}
                                    label={
                                        campaignDetail?.progress
                                            ? campaignDetail.progress.charAt(0).toUpperCase() +
                                            campaignDetail.progress.slice(1)
                                            : "--"
                                    }
                                />
                            </Stack>
                        </Box>
                        <CardContent >
                            <Box
                                sx={{
                                    display: "grid",
                                    gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
                                    columnGap: 4,
                                    rowGap: 3,
                                }}
                            >
                                {[
                                    {
                                        icon: <DescriptionOutlinedIcon fontSize="small" />,
                                        label: "Campaign Name",
                                        value: campaignDetail?.campaignName || "--",
                                    },
                                    {
                                        icon: <MusicNoteIcon fontSize="small" />,
                                        label: "Genre",
                                        value: campaignDetail?.genreName || "--",
                                    },
                                    {
                                        icon: <AutoAwesomeOutlinedIcon fontSize="small" />,
                                        label: "Mood",
                                        value: campaignDetail?.moodName || "--",
                                    },
                                    {
                                        icon: <LanguageOutlinedIcon fontSize="small" />,
                                        label: "Language",
                                        value: campaignDetail?.languageName || "--",
                                    },
                                    {
                                        icon: <AccessTimeOutlinedIcon fontSize="small" />,
                                        label: "Song Duration",
                                        value:
                                            campaignDetail?.song_duration ||
                                            campaignDetail?.songDuration ||
                                            "--",
                                    },
                                    {
                                        icon: <DateRangeOutlinedIcon fontSize="small" />,
                                        label: "Start Date",
                                        value: getDateAsPerFormat(
                                            campaignDetail?.startDate,
                                            "dd/MM/yyyy"
                                        ) || "--",
                                    },
                                    {
                                        icon: <DateRangeOutlinedIcon fontSize="small" />,
                                        label: "End Date",
                                        value: getDateAsPerFormat(
                                            campaignDetail?.endDate,
                                            "dd/MM/yyyy"
                                        ) || "--",
                                    },
                                    {
                                        icon: <AlternateEmailOutlinedIcon fontSize="small" />,
                                        label: "Account Mention",
                                        value: campaignDetail?.artistAccountsTag || "--",
                                    },
                                    {
                                        icon: <CurrencyRupeeIcon fontSize="small" />,
                                        label: "Budget",
                                        value: campaignDetail?.budget
                                            ? `${campaignDetail?.currency_symbol} ${campaignDetail?.budget}`
                                            : "--",
                                    },
                                    {
                                        icon: <DateRangeOutlinedIcon fontSize="small" />,
                                        label: 'Release Date',
                                        value: campaignDetail?.release_date
                                            ? getDateAsPerFormat(campaignDetail?.release_date, "dd/MM/yyyy")
                                            : "--",
                                    },
                                    {
                                        icon: <TagOutlinedIcon fontSize="small" />,
                                        label: "Suggested Hashtag",
                                        value: campaignDetail?.suggestedHastag || "--",
                                    },
                                    {
                                        icon: <LinkOutlinedIcon fontSize="small" />,
                                        label: "Instagram Audio Link",
                                        value: campaignDetail?.InstagramAudioLink ? (
                                            <a href={campaignDetail?.InstagramAudioLink} target="_blank" rel="noreferrer" style={{ color: "#E53935", textDecoration: "none" }}>
                                                {campaignDetail?.InstagramAudioLink}
                                            </a>
                                        ) : "--",
                                    },
                                    {
                                        icon: <InstagramIcon fontSize="small" />,
                                        label: "Reel Count",
                                        value: campaignDetail?.targetReelsCount || "--",
                                    },
                                    {
                                        icon: <InstagramIcon fontSize="small" />,
                                        label: "Story Count",
                                        value: campaignDetail?.targetStoryCount || "--",
                                    },
                                    {
                                        icon: <YouTubeIcon fontSize="small" />,
                                        label: "Shorts Count",
                                        value: campaignDetail?.targetShortsCount || "--",
                                    },
                                    {
                                        icon: <InstagramIcon fontSize="small" />,
                                        label: "Post Count",
                                        value: campaignDetail?.targetPostsCount || "--",
                                    },
                                    {
                                        icon: <CurrencyRupeeIcon fontSize="small" />,
                                        label: "Package",
                                        value: campaignDetail?.packages?.PackageName
                                            ? `${campaignDetail?.packages?.PackageName} - ₹${campaignDetail?.packages?.PackageAmount || ""}`
                                            : "--",
                                    },
                                    {
                                        icon: <DescriptionOutlinedIcon fontSize="small" />,
                                        label: "Special Notes",
                                        value: campaignDetail?.notes || "--",
                                        fullWidth: true,
                                    },

                                ].map((item, index) => (
                                    <Box
                                        key={index}
                                        sx={{
                                            display: "flex",
                                            gap: 1.5,
                                            gridColumn: item.fullWidth ? "1 / -1" : "auto",
                                        }}
                                    >
                                        {/* Icon */}
                                        <Box
                                            sx={{
                                                mt: "2px",
                                                color: "#7A7A7A",
                                                flexShrink: 0,
                                            }}
                                        >
                                            {item.icon}
                                        </Box>

                                        {/* Text */}
                                        <Box>
                                            <Typography
                                                sx={{
                                                    fontSize: 12,
                                                    fontWeight: 500,
                                                    color: "#7A7A7A",
                                                    textTransform: "uppercase",
                                                    letterSpacing: "0.04em",
                                                }}
                                            >
                                                {item.label}
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    fontSize: 14,
                                                    fontWeight: 400,
                                                    color: "#222",
                                                    mt: 0.5,
                                                }}
                                            >
                                                {item.value}
                                            </Typography>
                                        </Box>
                                    </Box>
                                ))}


                            </Box>


                            {/* <Box className="d-flex gap-2 mt-3">
                                <List sx={{ columnCount: 3 }}>
                                    {[
                                        { label: 'Submit campaign:', value: 'Done' },
                                        { label: 'Under review:', value: '25%' },
                                        { label: 'Live:', value: '75%' },
                                        { label: 'Completed:', value: '100%' },
                                        { label: 'Rejected:', value: '0%' },
                                    ].map((item, index) => (
                                        <ListItem
                                            key={index}
                                            disablePadding>
                                            <ListItemText primary={<Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: '600' }}>{item.label}</Typography>} secondary={item.value} />
                                        </ListItem>
                                    ))}
                                </List>
                                <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                                    <CircularProgress variant="determinate" value={statusCount} size={115} />
                                    <Box
                                        sx={{
                                            top: 0,
                                            left: 0,
                                            bottom: 0,
                                            right: 0,
                                            position: 'absolute',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <Typography
                                            variant="caption"
                                            component="div"
                                            sx={{ color: 'text.secondary', fontSize: '20px' }}
                                        >
                                            {statusCount + `%`}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Box> */}
                        </CardContent>

                    </Card>
                    <Card sx={{ borderRadius: 3, p: 2, mt: 2 }}>
                        <Typography sx={{ fontsize: '30px', fontWeight: 600 }}>Platform</Typography>
                        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: 1 }}>
                            {(campaignDetail?.platform || []).map((item, index) => (
                                <Box
                                    key={index}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1.5,
                                        px: 1.5,
                                        py: 0.75,
                                        borderRadius: "8px",
                                        border: "1px solid #E0E0E0",
                                        backgroundColor: "#FFF",
                                        // minWidth: "140px",
                                    }}
                                >
                                    {/* Icon */}
                                    <Box
                                        sx={{
                                            width: 32,
                                            height: 32,
                                            borderRadius: "50%",
                                            border: "1px solid #E0E0E0",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        {getPlatformIcon(item.platformName)}
                                    </Box>

                                    {/* Label */}
                                    <Typography sx={{ fontSize: 14, fontWeight: 500 }}>
                                        {item.platformName}
                                    </Typography>
                                </Box>
                            ))}
                        </Box>
                        {/* <GetMoodGenreLanguage
                            label="Platform"
                            items={campaignDetail?.platform || []}
                            sliceCount={1}
                        /> */}
                    </Card>
                    {campaignDetail?.clip_timestamps?.length > 0 && (
                        <Card mt={2} sx={{ padding: 2, borderRadius: 3, mt: 2 }}>
                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    mb: 2,
                                }}
                            >
                                <Stack direction="row" spacing={1} alignItems="center">
                                    {/* <QueueMusicIcon sx={{ color: "#1DAFA1" }} /> */}
                                    <Typography sx={{ fontSize: 16, fontWeight: 600 }}>
                                        Clip Timestamps
                                    </Typography>
                                </Stack>

                                <Chip
                                    label={`${campaignDetail.clip_timestamps.length} ${campaignDetail.clip_timestamps.length > 1 ? "Clips" : "Clip"
                                        }`}
                                    sx={{
                                        backgroundColor: "#E6F7F5",
                                        color: "#1DAFA1",
                                        fontWeight: 500,
                                    }}
                                />
                            </Box>

                            <Stack spacing={2}>
                                {campaignDetail.clip_timestamps.map((clip, index) => (
                                    <Accordion
                                        key={clip.id || index}
                                        disableGutters
                                        elevation={0}
                                        sx={{
                                            backgroundColor: "#F1FBFA",
                                            borderLeft: "4px solid #1DAFA1",
                                            // borderRadius:3,
                                            borderTopLeftRadius: 4,
                                            borderTopRightRadius: 4,
                                            overflow: 'hidden',
                                            "&:before": { display: "none" },
                                        }}
                                    >
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            sx={{
                                                px: 3,
                                                py: 1.5,
                                            }}
                                        >
                                            <Typography sx={{ fontSize: 14, fontWeight: 500 }}>
                                                Clip Timestamp {index + 1}
                                            </Typography>
                                        </AccordionSummary>

                                        <AccordionDetails sx={{ px: 3, pb: 3 }}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={12} sm={6}>
                                                    <Stack direction="row" spacing={1} alignItems="flex-start">
                                                        <PlayArrowOutlinedIcon sx={{ fontSize: 20, color: "#6B7280" }} />
                                                        <Box>
                                                            <Typography sx={{ fontSize: 12, color: "#6B7280" }}>
                                                                START TIME
                                                            </Typography>
                                                            <Typography sx={{ fontSize: 18, fontWeight: 600 }}>
                                                                {clip.start_time || "--"}
                                                            </Typography>
                                                        </Box>
                                                    </Stack>
                                                </Grid>

                                                <Grid item xs={12} sm={6}>
                                                    <Stack direction="row" spacing={1} alignItems="flex-start">
                                                        <CropSquareOutlinedIcon sx={{ fontSize: 20, color: "#6B7280" }} />
                                                        <Box>
                                                            <Typography sx={{ fontSize: 12, color: "#6B7280" }}>
                                                                END TIME
                                                            </Typography>
                                                            <Typography sx={{ fontSize: 18, fontWeight: 600 }}>
                                                                {clip.end_time || "--"}
                                                            </Typography>
                                                        </Box>
                                                    </Stack>
                                                </Grid>
                                            </Grid>

                                            <Divider sx={{ my: 2, borderColor: "#E5E7EB" }} />

                                            {/* Reference Link */}
                                            <Stack direction="row" spacing={1} alignItems="flex-start">
                                                <OpenInNewIcon sx={{ fontSize: 20, color: "#6B7280" }} />
                                                <Box>
                                                    <Typography sx={{ fontSize: 12, color: "#6B7280" }}>
                                                        REFERENCE LINK
                                                    </Typography>
                                                    {clip.reference_link?.trim() ? (
                                                        <Typography
                                                            component="a"
                                                            href={clip.reference_link}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            sx={{
                                                                fontSize: 14,
                                                                color: "#E53935",
                                                                textDecoration: "none",
                                                                wordBreak: "break-all",
                                                                "&:hover": { textDecoration: "underline" },
                                                            }}
                                                        >
                                                            {clip.reference_link}
                                                        </Typography>
                                                    ) : (
                                                        <Typography sx={{ fontSize: 14 }}>—</Typography>
                                                    )}
                                                </Box>
                                            </Stack>

                                            <Divider sx={{ my: 2, borderColor: "#E5E7EB" }} />

                                            {/* Description */}
                                            <Stack direction="row" spacing={1} alignItems="flex-start">
                                                <DescriptionOutlinedIcon sx={{ fontSize: 20, color: "#6B7280" }} />
                                                <Box>
                                                    <Typography sx={{ fontSize: 12, color: "#6B7280" }}>
                                                        CONTENT CONCEPT
                                                    </Typography>
                                                    <Typography sx={{ fontSize: 14, color: "#111827" }}>
                                                        {clip.description?.trim() || "—"}
                                                    </Typography>
                                                </Box>
                                            </Stack>
                                        </AccordionDetails>
                                    </Accordion>
                                ))}
                            </Stack>
                        </Card>
                    )}
                    {/* Vendor Details Card */}
                    {(campaignDetail?.vendor_name || campaignDetail?.vendor_email || campaignDetail?.vendor_phone_number) && (
                        <Card sx={{ p: 2, borderRadius: 3, mt: 2 }}>
                            <Typography sx={{ fontSize: 16, fontWeight: 600, mb: 2 }}>
                                Vendor Details
                            </Typography>

                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ fontSize: 12, color: "#6B7280" }}>Vendor Name</Typography>
                                    <Typography sx={{ fontSize: 14, fontWeight: 500 }}>
                                        {campaignDetail?.vendor_name || "--"}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ fontSize: 12, color: "#6B7280" }}>Email</Typography>
                                    <Typography sx={{ fontSize: 14, fontWeight: 500 }}>
                                        {campaignDetail?.vendor_email || "--"}
                                    </Typography>
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ fontSize: 12, color: "#6B7280" }}>Phone Number</Typography>
                                    <Typography sx={{ fontSize: 14, fontWeight: 500 }}>
                                        {campaignDetail?.vendor_phone_number || "--"}
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Card>
                    )}

                    <Box mt={3} textAlign="right">

                        {campaignDetail?.progress === "Approved" && campaignDetail?.vendor_name ? (
                            <Button
                                variant="contained"
                                sx={{ bgcolor: "#F14950", fontWeight: "600", px: 4 }}
                                onClick={() => handlePayment({
                                    packageAmount: campaignDetail?.packages,
                                    songId: campaignDetail?.song || campaignDetail?.demo,
                                    promotionData: campaignDetail
                                })}
                            >
                                Proceed to Payment
                            </Button>
                        ) : (
                            <Tooltip title={campaignDetail?.progress !== "Approved"
                                ? "Campaign is not approved yet"
                                : "Vendor is not assigned yet"}>
                                <span>
                                    <Button
                                        variant="contained"
                                        disabled
                                        sx={{ px: 4, bgcolor: "#ccc", color: "#666", fontWeight: "600" }}
                                    >
                                        Payment Locked
                                    </Button>
                                </span>
                            </Tooltip>
                        )}

                    </Box>
                </Grid>
            </Grid>
        </Box >
    );
}
